module.exports = __webpack_public_path__ + "fonts/vivo-fonts.d71ffd16.woff";